import { CellContext } from "@tanstack/react-table";
import Chips from "../../chips";

export interface ChipsCellData {
  id: string;
  name: string;
}

export interface ChipsCellProps<TRowData, TCellData extends ChipsCellData>
  extends CellContext<TRowData, TCellData[]> {}

function parseFilterValue(value: any) {
  return (value as string)?.trim()?.toLowerCase() ?? "";
}

export function ChipsCellFilterFn(
  items: ChipsCellData[],
  _column: string,
  value: any
) {
  const stringValue = parseFilterValue(value);
  if (stringValue.length === 0) return true;

  return items.some((item) => item.name.toLowerCase().includes(stringValue));
}

export default function ChipsCell<TRowData, TCellData extends ChipsCellData>(
  props: ChipsCellProps<TRowData, TCellData>
) {
  const filter = parseFilterValue(props.column.getFilterValue());
  const chips = props.getValue();
  const selectedChips =
    props.column.getCanFilter() && filter.length >= 1
      ? chips.filter((chip) => chip.name.toLowerCase().includes(filter))
      : [];
  const remainingChips = chips.filter((chip) => !selectedChips.includes(chip));
  const mergedChips = [...selectedChips, ...remainingChips];

  const { enableChipAdd, onChipAdd, onChipSelected } =
    props.cell.getContext().table.options.meta ?? {};

  return (
    <Chips
      chips={mergedChips.map((chip) => ({
        id: chip.id,
        label: chip.name,
        variant: selectedChips.includes(chip) ? "primary" : "light",
      }))}
      limit={10}
      size="sm"
      enableAdd={enableChipAdd}
      onChipAdd={() => onChipAdd?.(props.row.original)}
      onChipClicked={(chip) =>
        onChipSelected?.(
          props.row.original,
          mergedChips.find((x) => x.id === chip.id)!
        )
      }
    />
  );
}
